module.exports = __webpack_public_path__ + "img/18.485f608b.jpg";